/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import { handledCollab, handleCIQ } from "../../core/_requests";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as chat from "../../../../../../app/modules/chat/redux/ChatSlice";
import * as chatV2 from "../../../../../../app/modules/chat/redux/ChatSlice.v2";
import { createNotificationAnotherUser } from "../../../../../../db/serviceUser";
import { Link } from "react-router-dom";
import { Collaboration, Room } from "src/app/models/Chat";
import { fetchRooms } from "src/app/modules/chat/services";
import { Timestamp } from "@firebase/firestore-types";

const disableHandleCIQ = (
  lastInteractionDate: Timestamp | undefined,
  accountType: string | undefined
) => {
  if (!accountType || !lastInteractionDate) {
    return false;
  }

  if (accountType === "whatsapp") {
    const today = new Date();
    const lastInteraction = lastInteractionDate.toDate();

    const timeDifference = today.getTime() - lastInteraction.getTime();

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference > 1;
  } else {
    return false;
  }
};

type Props = {
  room: Room;
  collaboration: Collaboration;
};

const CIQActionsCell: FC<Props> = ({ room, collaboration }) => {
  const dispatch = useDispatch();
  const collaborationId = collaboration?.id;
  const roomId = room?.id;
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (room && room?.lastCustomerInteractionAt) {
      const disabled = disableHandleCIQ(
        room?.lastCustomerInteractionAt,
        room?.accountData?.type
      );
      setIsDisabled(disabled);
    }
  }, [room?.lastCustomerInteractionAt, room?.accountData?.type]);

  const handleChat = async () => {
    let collaborationData: Collaboration = collaboration;
    const handleCIQResult = await handleCIQ(collaborationId, roomId);
    const rooms = await fetchRooms(collaboration?.id);
    const countRooms = rooms?.length;
    // if (countRooms > 0) {
    //   collaboration.roomsModel = rooms;
    // }
    console.log("handle ciq result", handleCIQResult);
    if (handleCIQResult) {
      dispatch(
        chatV2.setSelectedCollaboration({
          chatType: "myChat",
          id: collaborationData?.id,
        })
      );
      dispatch(
        chatV2.setSelectedRoom({
          chatType: "myChat",
          id: room?.id,
        })
      );
      dispatch(chatV2.setActiveTab("myChat"));
      dispatch(
        chatV2.removeCollaboration({
          chatType: "allChat",
          id: collaborationData?.id,
        })
      );
      if (
        collaboration.company &&
        collaboration.company?.id &&
        collaboration.customer
      ) {
        createNotificationAnotherUser(collaboration);
      }
    }
  };

  return (
    <div className="d-flex flex-row">
      <Link
        className={`btn btn-primary btn-sm p-2 py-1 mt-0 ${
          isDisabled ? "disabled" : ""
        }`}
        to={isDisabled ? "#" : "/handled-customer"}
        onClick={async (e) => {
          if (isDisabled) {
            e.preventDefault();
            return;
          }
          await handleChat();
        }}
        data-testid="button-handle"
      >
        {t("CIQ.Button.Handle")}
      </Link>
    </div>
  );
};

export { CIQActionsCell };
